import { render, staticRenderFns } from "./PrivateInsurance.vue?vue&type=template&id=096898c8&"
import script from "./PrivateInsurance.vue?vue&type=script&lang=js&"
export * from "./PrivateInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports